export default __webpack_public_path__ + "static/media/cold-coffee.d5be6506.webp";